import { del, post, publicGet } from './core';

// Story 066 — Web Push API client.

export interface VapidKeyResponse {
  publicKey: string;
}

export interface SubscribeRequest {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  userAgent?: string;
}

export interface UnsubscribeRequest {
  endpoint: string;
}

export interface TestPushResponse {
  sent: number;
  removed: number;
}

// Public — frontend reads the VAPID public key before subscribing. Returns
// null if the tenant has no VAPID configuration (503), so callers can hide
// the push UI cleanly.
export async function getVapidPublicKey(): Promise<string | null> {
  try {
    const res = await publicGet<VapidKeyResponse>('/push/vapid-key');
    return res.publicKey;
  } catch {
    return null;
  }
}

export function postPushSubscription(input: SubscribeRequest): Promise<{ ok: true }> {
  return post('/push/subscriptions', input);
}

export function deletePushSubscription(endpoint: string): Promise<{ ok: true }> {
  return del('/push/subscriptions', { endpoint });
}

export function sendTestPush(): Promise<TestPushResponse> {
  return post('/push/test', {});
}
